import { css } from '@emotion/core';

import {
  minimumWidth,
  styled,
  pxToRem,
  Heading,
  textStyle,
} from '@feast-it/ui/light';

export const Wrapper = styled.div(
  ({ theme }) => css`
    width: 100%;
    margin: 0 auto;
    max-width: ${pxToRem(510)};

    ${minimumWidth(theme.breakpoints.large)} {
      max-width: ${pxToRem(1060)};
    }
  `
);

export const StyledHeading = styled(Heading)(
  ({ theme }) => css`
    text-align: center;

    ${minimumWidth(theme.breakpoints.medium)} {
      ${textStyle(theme, 'headingExtraLarge', 'black')}
    }
  `
);

export const GridWrapper = styled.section(
  ({ theme }) => css`
    display: grid;
    grid-column-gap: ${theme.spacing[4]};
    margin-top: ${theme.spacing[12]};
    grid-row-gap: ${theme.spacing[9]};

    ${minimumWidth(theme.breakpoints.medium)} {
      grid-column-gap: ${theme.spacing[10]};
    }

    ${minimumWidth(theme.breakpoints.large)} {
      grid-template-columns: repeat(2, 1fr);
    }
  `
);
